import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
import { faqs } from '../../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section tone="white" data-id="element-140" data-mp="124pqlabttlk2">
      <Eyebrow data-id="element-141" data-mp="1pshezcan5p1p">Preguntas frecuentes</Eyebrow>
      <Heading data-id="element-142" data-mp="1pspr31yxwqbu">Resolvemos tus últimas dudas</Heading>

      <div className="mt-7 space-y-2.5" data-id="element-143" data-mp="1ur0zr9di0ush">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={faq.question} className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" data-id="element-144" data-mp="1g1mqe19xadd3" data-mpi={i}>
              <h3 data-id="element-145" data-mp="28r21ss5i289j">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-146" data-mp="28qjyjbkf6ts4">
                  <span className="text-[14.5px] font-extrabold leading-snug text-navy sm:text-base" data-id="element-147" data-mp="2jr5mf0mi832o">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-148" data-mp="2yhcymylx4pux" />
                </button>
              </h3>

              <AnimatePresence initial={false} data-id="element-149" data-mp="32hdkh4bck3c0">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: 'easeOut'
            }} data-id="element-150" data-mp="3hee56nv4ey0z">
                    <p className="px-4 pb-4 text-[14px] leading-relaxed text-navy/70 sm:text-[15px]" data-id="element-151" data-mp="1i33ll0n4mnje">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <SectionCTA promise="Sin suscripciones, sin letras pequeñas: un pago y el sistema es tuyo." label="Quiero acceder ahora" data-id="element-152" data-mp="2gpkolrau4lle" />
    </Section>;
}